import React, { useContext } from "react";
import { useHistory } from "react-router";
import { AppContext, RequestResponse } from "../context";
import { LOCAL_KEY } from "@/App";

import CountUp from "react-countup";
import NftButton from "@/components/Button";
import styles from "./index.module.css";
import usePageTracking from "@/utils/usePageTracking";
import GlobalFooter from "@/components/GlobalFooter";
import useQuery from "@/utils/useQuery";

const cx = require("classnames");

const Home: React.FC = () => {
  const history = useHistory();
  const query = useQuery();

  const default_address = query.get("address") || "";

  const [input_cls, setAcls] = React.useState("animate__bounceInDown");
  const [load_cls, setBcls] = React.useState(styles.hidden);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [address, setAddress] = React.useState<string>("");
  const [err, setErr] = React.useState<string | undefined>(undefined);
  const [isNext, setNext] = React.useState(false);

  let is = false;
  // let num = 0;
  const inputRef = React.useRef(null);

  const { dispatch } = useContext(AppContext);

  // Google 统计
  usePageTracking();

  React.useEffect(() => {
    if (default_address.length > 1) {
      showLoading();
      fetchData(default_address);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = () => {
    // @ts-ignore 输入框失去焦点
    inputRef?.current?.blur();

    if (loading) return;

    setErr(undefined);
    setLoading(true);
    // 请求接口
    fetchData(address);
  };

  const fetchData = (adr: string) => {
    fetch(`/api/user_annual_report/${adr}`)
      .then((response) => {
        const { status, statusText } = response;
        if (status >= 200 && status < 400) {
          return response.json();
        }
        throw new Error(statusText);
      })
      .then((res: RequestResponse) => {
        if (res.code === 0 && res.msg === "success") {
          // num +=1;
          if (res.data.loading) {
            setTimeout(() => {
              fetchData(adr);
            }, 1000);
            throw new Error("loop");
          }

          setLoading(false);
          dispatch({ data: res.data });
          localStorage.setItem(LOCAL_KEY, JSON.stringify(res.data));
          showLoading();
          setTimeout(() => {
            history.push("/content");
          }, 1000);
          return res.data;
        }
        throw new Error(res.msg);
      })
      .catch((err) => {
        console.log(err.message)
        if (err.message === "loop") {
          return showLoading();
        }
        setTimeout(() => {
          hiddenLoading();
        }, 4000);
        setLoading(false);
        setErr(err.message);
      });
  };

  const showLoading = () => {
    if (isNext || is) return;
    setNext(true);
    is = true;

    if (default_address.length > 1) {
      setAcls(styles.hidden);
      setBcls(`animate__bounceInDown ${styles.show}`);
      return;
    }

    setNext(true);
    // input 框淡出
    setAcls(`animate__backOutDown`);
    // loading 显示
    setBcls(`animate__bounceInDown ${styles.show}`);
    // input 框隐藏
    setTimeout(() => {
      setAcls(styles.hidden);
    }, 400);
  };

  const hiddenLoading = () => {
    setNext(false);
    setAcls(`animate__bounceInDown`);
    setBcls(styles.hidden);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onClick();
    }
  };

  const delayTime = loading ? 2000 : 50;

  return (
    <div className={styles.home_bg}>
      <div className={cx(styles.window, "animate__animated", input_cls)}>
        <div className={styles.window_text}>
          <span>Discover Your</span>
          <span>2022 NFT</span>
          <span>Glory</span>
          <span>Moments</span>
          <em className={styles.err}>{err}</em>
          <input
            className={styles.window_input}
            placeholder="Enter wallet address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            onKeyDown={onKeyDown}
            ref={inputRef}
          />
          <NftButton onClick={onClick} type="primary">
            Check Now
          </NftButton>
        </div>
        <img
          className={styles.mobile_window}
          src={require("./window_small.png")}
          alt=""
        />
        <img className={styles.eth1} src={require("./eth1.png")} alt="" />
        <img className={styles.eth2} src={require("./eth2.png")} alt="" />
      </div>
      <div
        className={cx(styles.process_box, "animate__animated", load_cls)}
        style={{ animationDelay: "300ms" }}
      >
        <div className={styles.process_item}>
          <span className={styles.process_title}>LOADING...</span>
          {isNext && (
            <div className={styles.process}>
              {new Array(10).fill("").map((v, index) => (
                <span
                  key={index}
                  style={{ animationDelay: `${600 + delayTime * index}ms` }}
                  className={styles.show_process}
                />
              ))}
            </div>
          )}
          <div className={styles.process_percent}>
            <CountUp duration={loading ? 20 : 0.5} end={100} />
            <span>%</span>
          </div>
        </div>
        <img
          className={styles.big_window}
          src={require("./window_big.png")}
          alt=""
        />
      </div>
      <GlobalFooter />
    </div>
  );
};

export default Home;
